
export function findFocusable(el, includeHidden) {
    if ( includeHidden === void 0 ) includeHidden = false;

    var els = el.querySelectorAll("input, select, textarea, button, object, a[href], [tabindex]");
    return Array.prototype.filter.call(els, function (el) {
        if (el.hasAttribute('tabindex')) {
            var tabIndex = parseInt(el.getAttribute('tabindex'));
            if (isNaN(tabIndex) || tabIndex < 0) { return false; }
        }
        if (!includeHidden && !el.offsetParent) { return false; }
        return true;
    });
}

export function findFirstFocusable(el) {
    return findFocusable(el)[0];
}
export function findLastFocusable(el) {
    return findFocusable(el).pop();
}